import { takeEvery, put, call } from "redux-saga/effects";

import {
  getServicesAPI,
  addServiceAPI,
  getServiceAPI,
  updateServiceAPI,
  uploadServiceIconAPI,
  deleteServiceAPI,
} from "../../../helpers/backend.helper";
import {
  GET_SERVICES,
  ADD_SERVICE,
  GET_SERVICE,
  UPDATE_SERVICE,
  DELETE_SERVICE,
  UPLOAD_SERVICE_ICON,
} from "./actionTypes";
import {
  addServiceError,
  addServiceSuccess,
  deleteServiceError,
  deleteServiceSuccess,
  getServiceError,
  getServicesError,
  getServicesSuccess,
  getServiceSuccess,
  updateServiceError,
  updateServiceSuccess,
  uploadServiceIconSuccess,
  uploadServiceIconError,
} from "./actions";

function* getServices({ payload: { request } }) {
  try {
    const response = yield call(getServicesAPI, request);
    if (response) {
      yield put(getServicesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getServicesError(error));
  }
}

function* addService({ payload: { request } }) {
  try {
    const response = yield call(addServiceAPI, request);
    if (response) {
      yield put(addServiceSuccess());
    }
  } catch (error) {
    yield put(addServiceError(error));
  }
}

function* getService({ payload: { id } }) {
  try {
    const response = yield call(getServiceAPI, id);
    if (response) {
      yield put(getServiceSuccess(response?.data));
    }
  } catch (error) {
    yield put(getServiceError(error));
  }
}

function* updateService({ payload: { request } }) {
  try {
    const response = yield call(updateServiceAPI, request);
    if (response) {
      yield put(updateServiceSuccess());
    }
  } catch (error) {
    yield put(updateServiceError(error));
  }
}

function* deleteService({ payload: { id } }) {
  try {
    const response = yield call(deleteServiceAPI, id);
    if (response) {
      yield put(deleteServiceSuccess());
    }
  } catch (error) {
    yield put(deleteServiceError(error));
  }
}

function* uploadServiceIcon({ payload: { icon } }) {
  try {
    const response = yield call(uploadServiceIconAPI, icon);
    if (response) {
      yield put(uploadServiceIconSuccess(response?.data));
    }
  } catch (error) {
    yield put(uploadServiceIconError(error));
  }
}

function* servicesSaga() {
  yield takeEvery(GET_SERVICES, getServices);
  yield takeEvery(ADD_SERVICE, addService);
  yield takeEvery(GET_SERVICE, getService);
  yield takeEvery(UPDATE_SERVICE, updateService);
  yield takeEvery(DELETE_SERVICE, deleteService);
  yield takeEvery(UPLOAD_SERVICE_ICON, uploadServiceIcon);
}

export default servicesSaga;
